import script from "./GalleryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryPage.vue?vue&type=script&setup=true&lang=js"

import "./GalleryPage.vue?vue&type=style&index=0&id=d19ed0d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d19ed0d8"]])

export default __exports__